import { Provider } from 'react-redux'
import type { ReactNode } from 'react'
import { store } from '../store'
import { ThemeProvider } from './ThemeProvider'
import { ErrorBoundary } from './ErrorBoundary'
import { ToastHost } from './ToastHost'
import { WsProvider } from './WsProvider'

/**
 * Ворота сеанса живут в маршрутах (`app/router/routes.tsx`), а не здесь: вход, заявка на доступ
 * и приглашение открываются без сеанса, а кабинет — только с ним и с выбранной компанией.
 *
 * Хост уведомлений стоит здесь, а не в раскладке кабинета: тост обязан долететь и с экрана
 * входа, и со стенда компонентов, и из-под ErrorBoundary раскладки. Он сосед ворот, а не их
 * ребёнок: сообщение о сбое должно быть видно и на экране «сессия не загрузилась». Очередь
 * при этом живёт в `shared/lib/toast` — хост её только рисует.
 *
 * `WsProvider` — сосед без своего UI: один сокет на приложение, встаёт при живом сеансе и
 * закрывается при выходе. На входе и стенде кеш сеанса пуст, поэтому сокета там нет.
 */
export function AppProviders({ children }: { children: ReactNode }) {
  return (
    <ErrorBoundary>
      <Provider store={store}>
        <ThemeProvider>
          {children}
          <WsProvider />
          <ToastHost />
        </ThemeProvider>
      </Provider>
    </ErrorBoundary>
  )
}
